import { RotateFadingClock } from 'assets/icons';
import Tooltip from 'components/tooltips/Tooltips';
import { formatLastUpdate } from 'helper/lastUpdate';

/**
 * When a section was last touched, as an icon in the card's action group
 * rather than a line under its content.
 *
 * The wording is unchanged — "Mis à jour il y a 7 jours par William MESLIEN" —
 * it just moves into the tooltip: on a page of stacked cards, a date per card
 * competed with what each card is actually about.
 *
 * Renders nothing without a log entry. That means the company was filled in
 * before logging existed, not that it was never touched, so an empty slot says
 * less wrong than a made-up date.
 */
const LastUpdateIcon = ({ lastUpdate, color = '#6B7280' }) => {
  const label = formatLastUpdate(lastUpdate);
  if (!label) return null;

  return (
    <Tooltip text={label} placement={'top'}>
      <span className={'my-auto shrink-0 cursor-help'}>
        {/* The default grey is the cards' secondary tone; the post-it passes
            its own, having a background of its own. */}
        <RotateFadingClock wh={20} color={color} />
      </span>
    </Tooltip>
  );
};

export default LastUpdateIcon;
